/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendPaymentsMonthlyFromInvestmentsCompanyCommand } from '../../models/send-payments-monthly-from-investments-company-command';
import { Success } from '../../models/success';

export interface SendContractsFromInvestmentsCompanyToAdminAsync$Plain$Params {
      body?: SendPaymentsMonthlyFromInvestmentsCompanyCommand
}

export function sendContractsFromInvestmentsCompanyToAdminAsync$Plain(http: HttpClient, rootUrl: string, params?: SendContractsFromInvestmentsCompanyToAdminAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendContractsFromInvestmentsCompanyToAdminAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendContractsFromInvestmentsCompanyToAdminAsync$Plain.PATH = '/api/report/admin/contracts-from-investments-company';
